import { Col, Row, Space, Button } from "antd";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";

import { DatePicker, Input, RadioGroup, Select } from "components/form";
import styles from "../styles/UserFilter.module.css";
import useStatusFlagOption from "components/elements/Select/StatusDropdown";
import { useTranslation } from "react-i18next";

const UserListFilter = ({
  initialValues = {},
  shiftOptions = [],
  titleNameOptions = [],
  employeeTypeOptions = [],
  modifiedPositionOptions = [],
  organizationUnderOptions = [],
  welfareList = [],
  welfareOption = [],
  welfareTypeOptions = [],
  dataFlag = null,
  supervisorOptions = [],
  roleOptions = [],
  shiftDropDown = [],
  onCancel = () => { },
  onSubmit = () => { },
  onSearch = () => { },
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [optionType, setOptionType] = useState(null);
  const flagPage = null;
  const { modifiedStatus = [] } = useStatusFlagOption()
  const statusOption = [
    {
      value: "All",
      name: "All"
    },
    {
      value: "Active",
      name: "Active"
    },
    {
      value: "Inactive",
      name: "Inactive"
    },
    {
      value: "Delete",
      name: "Delete"
    }
  ]

  const isHr = [{ value: "Yes", name: "y" }, { value: "No", name: "n" }]
  return (

    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        onSubmit({
          ...values,
        });
      }}

    // validationSchema={schema}
    >
      {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => {
        return (

          <Form>
            {dataFlag == "userList" && (
              <Row gutter={[0, 16]} className={styles.filter} >
                <Col span={6} style={{ padding: "0px 8px" }}>
                  <Input
                    name="employeeNo"
                    label={t('translation.userlist_employeeId')}
                    placeholder={t('translation.userlist_employeeId')}
                    size="large"
                  />
                </Col>
                <Col span={6} style={{ padding: "0px 8px" }}>
                  <Input
                    name="name"
                    label={t('user_management.label.fullname')}
                    placeholder={t('user_management.label.fullname')}
                    size="large"
                  />
                </Col>
                <Col span={6} style={{ padding: "0px 8px" }}>
                  <Select
                    name="roleId"
                    label={t('translation.role.entity')}
                    placeholder={t('translation.role.entity')}
                    size="large"
                    options={roleOptions}
                  />
                </Col>
                {/* <Col span={8}>
                  <Select
                    name="directorySupervisor"
                    label={t('tab.menu.label.supervisor')}
                    placeholder={t('tab.menu.label.supervisor')}
                    size="large"
                    options={supervisorOptions}
                  />
                </Col> */}
                <Col span={6} style={{ padding: "0px 8px" }}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('translation.status')}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>

              </Row>
            )}
            {dataFlag == "role" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                <Col span={12}>
                  <Input
                    name="role"
                    label={t('userList.label.role')}
                    placeholder={t('userList.label.role')}
                    size="large"
                  />
                </Col>

                <Col span={12}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('translation.status')}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>

              </Row>
            )}

            <Row justify="end">
              <Space size={12} className={styles.filterbtn}>
                <Button type="default" onClick={resetForm} style={{ width: "100px", height: "44px", borderRadius: "8px", padding: "8px 16px" }}>
                  {t("common.clear").toUpperCase()}
                </Button>
                <Button type="primary" htmlType="submit" style={{ width: "100px", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}>
                  {t("creatTamplete.Search").toUpperCase()}
                </Button>
              </Space>
            </Row>

          </Form>
        );
      }}
    </Formik>
  );
};

export default UserListFilter;
